import { render, staticRenderFns } from "./Img.vue?vue&type=template&id=061407f6&scoped=true&"
import script from "./Img.vue?vue&type=script&lang=js&"
export * from "./Img.vue?vue&type=script&lang=js&"
import style0 from "./Img.vue?vue&type=style&index=0&id=061407f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061407f6",
  null
  
)

export default component.exports